<template>
  <div>
    <mdb-row>
      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label for="spouseEmerFirstName" class="form__label">Nombre(s):</label>
            <input
              v-model="spouseEmerFirstName"
              type="text"
              id="spouseEmerFirstName"
              class="form__input"
              value
              style="text-transform: capitalize !important;"
            />
            <validation-error :validation="$v.spouseEmerFirstName" />
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label for="spouseEmerLastName" class="form__label">Apellido Paterno:</label>
            <input
              v-model="spouseEmerLastName"
              type="text"
              id="spouseEmerLastName"
              class="form__input"
              value
              style="text-transform: capitalize !important;"
            />
            <validation-error :validation="$v.spouseEmerLastName" />
          </div>
        </div>
      </mdb-col>

      <mdb-col md="4" style="margin-bottom: 10px;">
        <div class="form__group">
          <div class="form__group">
            <label for="spouseEmerMotherLastName" class="form__label">Apellido Materno:</label>
            <input
              type="text"
              v-model="spouseEmerMotherLastName"
              id="spouseEmerMotherLastName"
              class="form__input"
              value
              style="text-transform: capitalize !important;"
            />
            <validation-error :validation="$v.spouseEmerMotherLastName" />
          </div>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col md="4" sm="8" sx="12" style="margin-bottom: 10px;">
        <div class="form__group">
          <label for="spouseEmerRelationship" class="form__label">Parentesco:</label>
          <select v-model="spouseEmerRelationship" class="browser-default custom-select">
            <option selected>Selecciona una opción</option>
            <option value="Madre">Madre</option>
            <option value="Padre">Padre</option>
            <option value="Herman@">Herman@</option>
            <option value="Hij@">Hij@</option>
            <option value="Ti@">Ti@</option>
          </select>
          <validation-error :validation="$v.spouseEmerRelationship" />
        </div>
      </mdb-col>

      <mdb-col lg="4" md="8" sm="12" style="margin-bottom: 10px;">
        <div class="form__group">
          <label class="form__label" for="spouseEmerPhone">Teléfono Celuar:</label>
          <input
            type="text"
            v-model="spouseEmerPhone"
            placeholder="(+52)"
            id="spouseEmerPhone"
            class="form__input"
            v-mask="'##########'"
          />
          <validation-error :validation="$v.spouseEmerPhone" />
        </div>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mdbRow, mdbCol } from "mdbvue";
import ValidationError from "../misc/ValidationError";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import {
  required,
  email,
  minLength,
  alphaNum,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";

export default {
  name: "SpouseEmergencyContact",
  components: {
    mdbRow,
    mdbCol,
    ValidationError,
  },
  directives: { mask },
  data() {
    return {
      spouseEmerFirstName: "",
      spouseEmerLastName: "",
      spouseEmerMotherLastName: "",
      spouseEmerRelationship: "",
      spouseEmerPhone: "",
    };
  },
  validations: {
    spouseEmerFirstName: {
      required,
    },
    spouseEmerLastName: {
      required,
    },
    spouseEmerMotherLastName: {
      required,
    },
    spouseEmerRelationship: {
      required,
    },
    spouseEmerPhone: {
      required,
    },
  },
  mounted() {
    var userAllData = JSON.parse(localStorage.getItem("userAllData"));
    var spouse = userAllData.beneficiaries.filter(function (item) {
      return item.beneficiaryType == "SPOUSE";
    });

    //console.log(spouse);

    if (spouse.length > 0) {
      this.getSopuseInfo(spouse[0]);
    }
  },
  methods: {
    getSopuseInfo(spouse) {
      var phone = spouse.phones.filter(function (item) {
        return item.phoneType == "Emergency";
      });

      if (phone.length > 0) {
        this.spouseEmerFirstName = phone[0].contactName.split(" ")[0];
        this.spouseEmerLastName = phone[0].contactName.split(" ")[1];
        this.spouseEmerMotherLastName = phone[0].contactName.split(" ")[2];
        this.spouseEmerRelationship = phone[0].contactRelationship;
        this.spouseEmerPhone = phone[0].phoneNumber;
      }
    },
    getFormdata() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return false;
      } else {
        let phoneList = {
          phone: this.spouseEmerPhone,
          contactName:
            this.spouseEmerFirstName +
            " " +
            this.spouseEmerLastName +
            " " +
            this.spouseEmerMotherLastName,
          contactRelationship: this.spouseEmerRelationship,
          phoneType: "Emergency",
        };

        return phoneList;
      }
    },
  },
  computed: {
       ...mapGetters({
      beneficiaries: "getBeneficiariesData"
    }),

  }
};
</script>